import {
  PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_BEGIN,
  PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_SUCCESS,
  PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_FAILURE,
  PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function xanocollectionNames(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_BEGIN,
    });
    const header = {
      headers: {
        Authorization: `Bearer ${args.token}`,
        'Content-Type': 'application/json',
      },
    };
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`https://x8ki-letl-twmt.n7.xano.io/api:meta/workspace/${args.workspaceId}/table/${args.idcol}/schema`, {
        headers: header.headers
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissXanocollectionNamesError() {
  return {
    type: PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_BEGIN:
      return {
        ...state,
        xanocollectionNamesPending: true,
        xanocollectionNamesError: null,
      };

    case PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_SUCCESS:
      return {
        ...state,
        xanocollectionNamesPending: false,
        xanocollectionNamesError: null,
        xanoCollectionNameData: action.data,
      };

    case PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_FAILURE:
      return {
        ...state,
        xanocollectionNamesPending: false,
        xanocollectionNamesError: action.data.error,
      };

    case PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_DISMISS_ERROR:
      return {
        ...state,
        xanocollectionNamesError: null,
      };

    default:
      return state;
  }
}
